import teleradiologistApi from '@custom/rtk-apis/teleradiologist/getTeleradiologist';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const teleradiologistSlice = createSlice({
  name: 'teleradiologistSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(teleradiologistApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(teleradiologistApi.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(teleradiologistApi.rejected, (state, {payload}) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default teleradiologistSlice.reducer;
